import { render, staticRenderFns } from "./TiersModule.vue?vue&type=template&id=365444f2&"
import script from "./TiersModule.vue?vue&type=script&lang=js&"
export * from "./TiersModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports